import React from "react";
import "bootstrap/dist/css/bootstrap.css";
import { Container, Row, Col, Button } from "reactstrap";
import Ambassador4Brand from "../assets/img/Ambassador4Brand.png";
import AmbassadorQr from "../assets/img/AmbassdorQr.png";
import { useHistory } from "react-router-dom";

function NewHome() {
  const history = useHistory();
  return (
    <Container fluid>
      <div className="d-block d-md-none bg-white font-weight-bold justify-content-center">
        <img
          src={Ambassador4Brand}
          alt="Ambassador4Brand"
          className="img-fluid"
        />
      </div>
      <div className="new-home h-100">
        <Row className="w-100">
          <Col sm={12} className="d-none d-md-block">
            <div className="mt-5">
              <img
                src={Ambassador4Brand}
                alt="Ambassador4Brand"
                className="img-fluid"
              />
            </div>
          </Col>
        </Row>
        <Row className="justify-content-left new-home_promotion-bar bg-white w-100 m-0">
          <Col
            xs={12}
            md={6}
            className="d-flex justify-content-center align-items-center"
          >
            <img
              src={AmbassadorQr}
              alt="AmbassadorQr"
              className="w-100 img-fluid"
            />
          </Col>
          <Col
            xs={12}
            md={6}
            className="d-flex flex-column justify-content-center align-items-center align-items-md-start px-0 mt-4 mt-md-0"
          >
            <Button
              size="md"
              className="font-weight-bold new-home_Enter-Button width-res mb-3"
              color="primary"
              onClick={() => history.push("/home")}
            >
              Fan LOGIN- Chat with Athlete here
            </Button>
            <Button
              size="md"
              className="font-weight-bold new-home_Enter-Button width-res"
              color="primary"
              onClick={() => history.push("/home-for-athlete")}
            >
              Teacher-Athlete LOGIN Here
            </Button>
          </Col>
        </Row>
      </div>
      <div className="d-flex d-md-none justify-content-center align-items-center bg-danger py-4 my-3">
        <h4 className="font-weight-bold text-white text-center mx-2 px-2 new-home-footer-text">
          STUDENT ATHLETES SERVE AS BRAND AMBASSADOR
        </h4>
      </div>
    </Container>
  );
}

export default NewHome;
